import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_claim_account_txn_line_RowClass,
} from '../../../dbschema';

export class ClaimAccountTxnLineContainerModel extends BaseContainerModel {
  bl_aat_claim_account_txn_line: bl_aat_claim_account_txn_line_RowClass = new bl_aat_claim_account_txn_line_RowClass();
}
